import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import './fonts/index.css';
import './index.css';
import App from './App';
import 'rxjs';
import store from './store';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';

addLocaleData([...en, ...fr]);

const locale = 'en';
const messages = {
    fr: require('./translations/fr.json'),
    en: require('./translations/en-US.json')
};
// Needed for material ui onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();
ReactDOM.render(
    <Provider store={store}>
        <IntlProvider locale={locale} messages={messages[locale]}>
            <App />
        </IntlProvider>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js